import { createAction, createActions } from 'src/utils/reduxUtils'

export const Logout = createActions('Logout')
export const SetAdminQueryFlags = createAction('SetAdminQueryFlags')
export const InternalFetchMe = createActions('InternalFetchMe')

export const AdminFetchOnboardingTemplate = createActions('AdminFetchOnboardingTemplate')
export const AdminSaveOnboardingTemplate = createActions('AdminSaveOnboardingTemplate')
export const AdminCreateOnboardingTemplate = createActions('AdminCreateOnboardingTemplate')
/** Seed the editor with an empty template scaffold when entering new-template mode. */
export const FlowEditorInitCreateDraft = createAction('FlowEditorInitCreateDraft')
export const FlowEditorSetDraft = createAction('FlowEditorSetDraft')
/** Apply a single FlowEditorDocumentOp to the draft (document is the source of truth). */
export const FlowEditorApplyOp = createAction('FlowEditorApplyOp')

// Flow editor live-updates preview (dry-run of the pending template changes,
// recomputed on every draft change).
export const AdminFetchTemplatePreview = createActions('AdminFetchTemplatePreview')
export const AdminFetchCustomer = createActions('AdminFetchCustomer')
export const AdminFetchCustomers = createActions('AdminFetchCustomers')
export const AdminCreateCustomer = createActions('AdminCreateCustomer')
export const AdminUpdateCustomer = createActions('AdminUpdateCustomer')
export const AdminLoginAsCustomer = createActions('AdminLoginAsCustomer')
export const AdminOnboardMasterContractor = createActions('AdminOnboardMasterContractor')

export const AdminFetchDocusignPartnerTemplates = createActions(
  'AdminFetchDocusignPartnerTemplates',
)
export const AdminFetchLmsTrainingList = createActions('AdminFetchLmsTrainingList')
export const AdminFetchYardstikPackages = createActions('AdminFetchYardstikPackages')
export const AdminFetchInsurancePolicies = createActions('AdminFetchInsurancePolicies')
export const AdminFetchGigsafeConfig = createActions('AdminFetchGigsafeConfig')
export const AdminSaveGigsafeConfig = createActions('AdminSaveGigsafeConfig')
export const AdminFetchMarkets = createActions('AdminFetchMarkets')
export const AdminCreateMarket = createActions('AdminCreateMarket')
export const AdminRenameMarket = createActions('AdminRenameMarket')
// Deliberately "…DocusignTemplates", not "…DocusignPartnerTemplates": the latter is the flow
// editor's own fetch of the same endpoint (see the design's §4.1) and must keep its identity.
export const AdminFetchDocusignTemplates = createActions('AdminFetchDocusignTemplates')
export const AdminCreateDocusignTemplate = createActions('AdminCreateDocusignTemplate')
export const AdminDeleteDocusignTemplate = createActions('AdminDeleteDocusignTemplate')
export const AdminFetchOnboardingTemplateList = createActions('AdminFetchOnboardingTemplateList')
export const AdminDeleteOnboardingTemplate = createActions('AdminDeleteOnboardingTemplate')
export const AdminRenameOnboardingTemplate = createActions('AdminRenameOnboardingTemplate')
export const AdminFetchInsuranceProducts = createActions('AdminFetchInsuranceProducts')
export const AdminCreateInsuranceProduct = createActions('AdminCreateInsuranceProduct')
export const AdminUpdateInsuranceProduct = createActions('AdminUpdateInsuranceProduct')
export const AdminDeleteInsuranceProduct = createActions('AdminDeleteInsuranceProduct')

// The customer Insurance tab (ENG-481). The fetch action is NOT declared here — the pre-existing
// `AdminFetchInsurancePolicies` above already exists for the flow editor's read of the same
// endpoint, and this slice takes over handling it rather than adding a second one.
export const AdminCreateInsurancePolicy = createActions('AdminCreateInsurancePolicy')
export const AdminUpdateInsurancePolicy = createActions('AdminUpdateInsurancePolicy')
export const AdminDeleteInsurancePolicy = createActions('AdminDeleteInsurancePolicy')
export const AdminCreateInsurancePolicyProduct = createActions('AdminCreateInsurancePolicyProduct')
export const AdminUpdateInsurancePolicyProduct = createActions('AdminUpdateInsurancePolicyProduct')
export const AdminDeleteInsurancePolicyProduct = createActions('AdminDeleteInsurancePolicyProduct')

// A separate fetch action from the pre-existing `AdminFetchLmsTrainingList`: that one writes
// into the flow-editor-scoped `collectStepReference` slice, which is keyed to a partnerId and
// reset per template. Reusing it would couple this page's loading and error state to the flow
// editor's. The endpoint is shared; the action and the slice are not.
export const AdminFetchLmsTrainingCatalog = createActions('AdminFetchLmsTrainingCatalog')
export const AdminCreateLmsTraining = createActions('AdminCreateLmsTraining')
export const AdminUpdateLmsTraining = createActions('AdminUpdateLmsTraining')
export const AdminDeleteLmsTraining = createActions('AdminDeleteLmsTraining')

export const AdminFetchRemoteConfigs = createActions('AdminFetchRemoteConfigs')
export const AdminCreateRemoteConfig = createActions('AdminCreateRemoteConfig')
export const AdminUpdateRemoteConfig = createActions('AdminUpdateRemoteConfig')
export const AdminDeleteRemoteConfig = createActions('AdminDeleteRemoteConfig')

export const AdminFetchInvoices = createActions('AdminFetchInvoices')
export const AdminFetchInvoiceDueInterest = createActions('AdminFetchInvoiceDueInterest')
export const AdminRunInvoiceAction = createActions('AdminRunInvoiceAction')
// Put by the batch saga after each invoice so the modal can render live progress. A plain
// action, not a request/success/failed triple: it is a store write, never an API call.
export const AdminSetInvoiceActionProgress = createAction('AdminSetInvoiceActionProgress')
/** Clears `actionRun` when the results modal closes. */
export const AdminClearInvoiceActionRun = createAction('AdminClearInvoiceActionRun')

export const AdminFetchAiDocumentReviewConfigs = createActions('AdminFetchAiDocumentReviewConfigs')
export const AdminCreateAiDocumentReviewConfig = createActions('AdminCreateAiDocumentReviewConfig')
export const AdminUpdateAiDocumentReviewConfig = createActions('AdminUpdateAiDocumentReviewConfig')
export const AdminDeleteAiDocumentReviewConfig = createActions('AdminDeleteAiDocumentReviewConfig')

export const AdminFetchOAuthClient = createActions('AdminFetchOAuthClient')
export const AdminCreateOAuthClient = createActions('AdminCreateOAuthClient')
export const AdminUpdateOAuthClient = createActions('AdminUpdateOAuthClient')
export const AdminRevokeOAuthTokens = createActions('AdminRevokeOAuthTokens')

export const AdminFetchWebhookSubscriptions = createActions('AdminFetchWebhookSubscriptions')
export const AdminCreateWebhookSubscription = createActions('AdminCreateWebhookSubscription')
export const AdminUpdateWebhookSubscription = createActions('AdminUpdateWebhookSubscription')
export const AdminFetchWebhookDeliveries = createActions('AdminFetchWebhookDeliveries')
export const AdminSendWebhook = createActions('AdminSendWebhook')

// Customer-scoped product entitlements. Fetched by CustomerLayout on customer select, because
// what a customer is entitled to gates what other tabs may offer — this replaces the
// single-purpose AdminFetchApiIntegrationProduct the Webhooks tab used to dispatch itself.
export const AdminFetchCustomerProducts = createActions('AdminFetchCustomerProducts')
export const AdminCreateCustomerProduct = createActions('AdminCreateCustomerProduct')
export const AdminUpdateCustomerProduct = createActions('AdminUpdateCustomerProduct')
export const AdminDeactivateCustomerProduct = createActions('AdminDeactivateCustomerProduct')

/**
 * Drops the delivery log when the customer changes. The deliveries REQUEST deliberately keeps
 * its rows so same-customer paging does not blank the grid, which means a customer switch needs
 * an explicit clear or the previous customer's deliveries stay on screen.
 */
export const ClearAdminWebhookDeliveries = createAction('ClearAdminWebhookDeliveries')

export const AdminFetchPaymentConfig = createActions('AdminFetchPaymentConfig')
export const AdminSavePayoutSettings = createActions('AdminSavePayoutSettings')
export const AdminSaveVendorFees = createActions('AdminSaveVendorFees')

export const AdminFetchOatfiBusiness = createActions('AdminFetchOatfiBusiness')
export const AdminSaveOatfiBusiness = createActions('AdminSaveOatfiBusiness')
export const AdminRequestOatfiUnderwriting = createActions('AdminRequestOatfiUnderwriting')
export const AdminUploadOatfiSupplementalData = createActions('AdminUploadOatfiSupplementalData')
export const AdminUploadHistoricalInvoices = createActions('AdminUploadHistoricalInvoices')
export const AdminCreateOatfiPaymentMethod = createActions('AdminCreateOatfiPaymentMethod')
export const AdminFetchPlaidLinkToken = createActions('AdminFetchPlaidLinkToken')
export const ClearAdminOatfiPlaidLink = createAction('ClearAdminOatfiPlaidLink')

// No `Admin` prefix, unlike every other action in this file — a leftover from when these six ran
// on a customer token rather than the admin's. They are ordinary internal-API actions now; every
// payload carries the `partnerId` the route takes in its path.
export const FetchGigsafeUsers = createActions('FetchGigsafeUsers')
export const InviteGigsafeUser = createActions('InviteGigsafeUser')
export const FetchGigsafeRoles = createActions('FetchGigsafeRoles')
export const FetchGigsafeRolePermissions = createActions('FetchGigsafeRolePermissions')
export const CreateGigsafeRole = createActions('CreateGigsafeRole')
export const UpdateGigsafeRole = createActions('UpdateGigsafeRole')
// Resets the whole slice. `FetchGigsafeUsers.REQUEST` deliberately keeps its rows so paging
// does not blank the table, which means nothing else drops the previous customer's users,
// roles or permissions when the route moves to another customer.
export const ClearGigsafeUserState = createAction('ClearGigsafeUserState')

// Internal Document Review — contractor queue. ENG-489.
export const AdminFetchDocumentReviewSteps = createActions('AdminFetchDocumentReviewSteps')
export const AdminFetchDocumentReviewStep = createActions('AdminFetchDocumentReviewStep')
export const AdminFetchReviewRejectionReasons = createActions('AdminFetchReviewRejectionReasons')
export const AdminApproveReviewStep = createActions('AdminApproveReviewStep')
export const AdminRecollectReviewStep = createActions('AdminRecollectReviewStep')

export const AdminFetchMcReviewDocuments = createActions('AdminFetchMcReviewDocuments')
export const AdminApproveMcDocument = createActions('AdminApproveMcDocument')
export const AdminRejectMcDocument = createActions('AdminRejectMcDocument')
// Schedulers Management (ENG-494). Two slices: the partner-scoped config list + detail, and the
// global template catalog — they have different permission gates server-side.
export const AdminFetchRetryConfigs = createActions('AdminFetchRetryConfigs')
export const AdminFetchRetryConfig = createActions('AdminFetchRetryConfig')
export const AdminUpdateRetryConfig = createActions('AdminUpdateRetryConfig')
export const AdminRescheduleRetryJob = createActions('AdminRescheduleRetryJob')
export const AdminFetchRetryConfigTemplates = createActions('AdminFetchRetryConfigTemplates')
export const AdminUpdateRetryConfigTemplate = createActions('AdminUpdateRetryConfigTemplate')

// Update Partner Driver. ENG-486 / ENG-487. One slice: search results, the open driver (from
// `/steps`) and its summary row (OTP + pending Yardstik, from `/search?partnerDriverId=`).
export const AdminSearchPartnerDrivers = createActions('AdminSearchPartnerDrivers')
export const AdminFetchPartnerDriver = createActions('AdminFetchPartnerDriver')
export const AdminFetchPartnerDriverSummary = createActions('AdminFetchPartnerDriverSummary')
export const AdminUpdatePartnerDriver = createActions('AdminUpdatePartnerDriver')
export const AdminUpdatePartnerDriverTemplate = createActions('AdminUpdatePartnerDriverTemplate')
export const AdminSwitchPartnerDriverOnboarding = createActions(
  'AdminSwitchPartnerDriverOnboarding',
)
export const AdminResetPartnerDriverStep = createActions('AdminResetPartnerDriverStep')
export const AdminCompleteFailedPartnerDriverStep = createActions(
  'AdminCompleteFailedPartnerDriverStep',
)
export const AdminUploadPartnerDriverStepDocuments = createActions(
  'AdminUploadPartnerDriverStepDocuments',
)
export const AdminDeletePartnerDriverStepDocuments = createActions(
  'AdminDeletePartnerDriverStepDocuments',
)
export const AdminCompletePartnerDriverBackgroundCheck = createActions(
  'AdminCompletePartnerDriverBackgroundCheck',
)
export const AdminCompletePartnerDriverVehicleInsurance = createActions(
  'AdminCompletePartnerDriverVehicleInsurance',
)
export const AdminCompletePartnerDriverLicense = createActions('AdminCompletePartnerDriverLicense')
export const AdminCompletePartnerDriverLmsTraining = createActions(
  'AdminCompletePartnerDriverLmsTraining',
)
export const AdminCompletePartnerDriverInsuranceDeclaration = createActions(
  'AdminCompletePartnerDriverInsuranceDeclaration',
)
// ENG-884 / ENG-885 / ENG-1214.
export const AdminCompletePartnerDriverVehicleRegistration = createActions(
  'AdminCompletePartnerDriverVehicleRegistration',
)
export const AdminCompletePartnerDriverDotNumber = createActions(
  'AdminCompletePartnerDriverDotNumber',
)
export const AdminSkipPartnerDriverStep = createActions('AdminSkipPartnerDriverStep')
export const AdminDeletePartnerDriverData = createActions('AdminDeletePartnerDriverData')
// Drops the open driver and its summary so a previous driver never flashes on the next page.
export const ClearPartnerDriverState = createAction('ClearPartnerDriverState')

// ── Payments Ops (ENG-491 / ENG-492 / ENG-493) ──────────────────────────────────────────────
export const AdminFetchPendingPayments = createActions('AdminFetchPendingPayments')
export const AdminFetchPendingPaymentDetails = createActions('AdminFetchPendingPaymentDetails')
export const AdminReviewPayment = createActions('AdminReviewPayment')
// No bulk endpoint exists: the saga loops single reviews (spec §7.1).
export const AdminBulkApprovePayments = createActions('AdminBulkApprovePayments')
/** `{ done, total }` after each chunk of a bulk approve settles. */
export const AdminBulkApprovePaymentsProgress = createAction('AdminBulkApprovePaymentsProgress')

export const AdminFetchMissingInvoiceTransactions = createActions(
  'AdminFetchMissingInvoiceTransactions',
)
export const AdminFetchPendingReviewTransactions = createActions(
  'AdminFetchPendingReviewTransactions',
)
export const AdminFetchPartnerPendingInvoices = createActions('AdminFetchPartnerPendingInvoices')
export const AdminAssignTransactionInvoice = createActions('AdminAssignTransactionInvoice')
export const AdminRefundTransaction = createActions('AdminRefundTransaction')
export const AdminAuthorizeTransaction = createActions('AdminAuthorizeTransaction')

export const AdminFetchRefunds = createActions('AdminFetchRefunds')
export const AdminExecuteRefund = createActions('AdminExecuteRefund')

export const AdminFetchBankOnboardings = createActions('AdminFetchBankOnboardings')
export const AdminStartBankOnboarding = createActions('AdminStartBankOnboarding')

export const AdminFetchUsBankEarnings = createActions('AdminFetchUsBankEarnings')
export const AdminFetchUsBankEarningOrders = createActions('AdminFetchUsBankEarningOrders')

export const AdminFetchWallets = createActions('AdminFetchWallets')

export const AdminRunReconciliation = createActions('AdminRunReconciliation')

// Fees Withdraw Reports. ENG-1212.
export const AdminFetchFeeWithdrawals = createActions('AdminFetchFeeWithdrawals')
export const AdminFetchFeeWithdrawalReport = createActions('AdminFetchFeeWithdrawalReport')

export const AdminFetchKillswitchFlags = createActions('AdminFetchKillswitchFlags')
export const AdminToggleKillswitch = createActions('AdminToggleKillswitch')
export const AdminFetchCapturedEvents = createActions('AdminFetchCapturedEvents')
export const AdminReplayCapturedEvent = createActions('AdminReplayCapturedEvent')
export const AdminDiscardCapturedEvent = createActions('AdminDiscardCapturedEvent')
export const AdminBulkReplayCapturedEvents = createActions('AdminBulkReplayCapturedEvents')
export const AdminReplayAllCapturedEvents = createActions('AdminReplayAllCapturedEvents')

// Users Management — internal admin users and roles. ENG-1207.
export const AdminFetchInternalUsers = createActions('AdminFetchInternalUsers')
export const AdminAssignInternalUserRole = createActions('AdminAssignInternalUserRole')
export const AdminSetInternalUserStatus = createActions('AdminSetInternalUserStatus')
export const AdminFetchInternalRoles = createActions('AdminFetchInternalRoles')
export const AdminFetchInternalRole = createActions('AdminFetchInternalRole')
export const AdminCreateInternalRole = createActions('AdminCreateInternalRole')
export const AdminUpdateInternalRole = createActions('AdminUpdateInternalRole')
